const GRAPH_API_KEY = process.env.REACT_APP_GRAPH_API_KEY || '';

if (!GRAPH_API_KEY) {
  console.warn('[graphApi] REACT_APP_GRAPH_API_KEY not set — subgraph queries will be disabled');
}

const CHAIN_SUBGRAPH = {
  Ethereum: "5zvR82QoaXYFyDEKLZ9t6v9adgnptxYpKpSbxtgVENFV",
  Arbitrum: "FbCGRftH4a3yZugY7TnbYgPJVEv2LvMT6oF1fxPe9aJM",
  Optimism: "Cghf4LfVqPiFw6fp6Y5X5Ubc8UpmUhSfJjq6BT4pMt9G",
  Polygon:  "3hCPRGf4z588SkYQoaELQ2gDGwIERqBjf9u79cHkjKfe",
  Base:     "GqzP4Xaehti8KSfQMv2GDCc8KyoYKehTjPJRxNDAyJ4y",
};

const LLAMA_CHAIN_SLUG = {
  Ethereum: "ethereum",
  Arbitrum: "arbitrum",
  Optimism: "optimism",
  Base:     "base",
  Polygon:  "polygon",
};

function graphEndpoint(chain) {
  if (!GRAPH_API_KEY) return null;
  const subgraphId = CHAIN_SUBGRAPH[chain];
  if (!subgraphId) return null;
  return `https://gateway.thegraph.com/api/${GRAPH_API_KEY}/subgraphs/id/${subgraphId}`;
}

async function querySubgraph(chain, query) {
  const url = graphEndpoint(chain);
  if (!url) return null;

  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ query }),
  });

  if (!res.ok) throw new Error(`The Graph responded ${res.status}`);
  const json = await res.json();
  if (json.errors) throw new Error(json.errors[0].message);
  return json.data;
}

export async function fetchPositionHistory(walletAddress, chain) {
  try {
    const query = `{
  positions(where: { owner: "${walletAddress.toLowerCase()}" }, first: 100) {
    id
    owner
    pool {
      id
      token0 { id symbol decimals }
      token1 { id symbol decimals }
      feeTier
    }
    tickLower { tickIdx }
    tickUpper { tickIdx }
    liquidity
    depositedToken0
    depositedToken1
    withdrawnToken0
    withdrawnToken1
    collectedFeesToken0
    collectedFeesToken1
    transaction {
      timestamp
      blockNumber
    }
  }
}`;

    const data = await querySubgraph(chain, query);
    return data ? data.positions : null;
  } catch (err) {
    console.warn("Failed to fetch position history:", err.message);
    return null;
  }
}

export async function fetchMintEvents(walletAddress, chain) {
  try {
    const query = `{
  mints(where: { origin: "${walletAddress.toLowerCase()}" }, orderBy: timestamp, orderDirection: desc, first: 200) {
    id
    timestamp
    pool { id token0 { id symbol decimals } token1 { id symbol decimals } feeTier }
    amount0
    amount1
    amountUSD
    tickLower
    tickUpper
    origin
  }
}`;

    const data = await querySubgraph(chain, query);
    return data ? data.mints : null;
  } catch (err) {
    console.warn("Failed to fetch mint events:", err.message);
    return null;
  }
}

export function computeIL(
  depositAmount0, depositAmount1,
  currentAmount0, currentAmount1,
  depositPrice0, depositPrice1,
  currentPrice0, currentPrice1
) {
  const depositValue = depositAmount0 * depositPrice0 + depositAmount1 * depositPrice1;
  const hodlValue = depositAmount0 * currentPrice0 + depositAmount1 * currentPrice1;
  const lpValue = currentAmount0 * currentPrice0 + currentAmount1 * currentPrice1;
  const il = hodlValue === 0 ? 0 : (lpValue - hodlValue) / hodlValue;

  return {
    il,
    ilPercent: il * 100,
    depositValue,
    hodlValue,
    lpValue,
  };
}

export function computePnL(currentValueUsd, feesCollectedUsd, unclaimedFeesUsd, depositValueUsd) {
  const totalReturn = currentValueUsd + feesCollectedUsd + unclaimedFeesUsd;
  const pnl = totalReturn - depositValueUsd;
  const pnlPercent = depositValueUsd === 0 ? 0 : (pnl / depositValueUsd) * 100;

  return { pnl, pnlPercent, totalReturn };
}

export async function fetchHistoricalPrices(tokenAddresses, timestamp, chain) {
  try {
    const slug = LLAMA_CHAIN_SLUG[chain];
    if (!slug) return null;

    const coins = tokenAddresses.map(addr => `${slug}:${addr}`).join(",");
    const url = `https://coins.llama.fi/prices/historical/${timestamp}/${coins}`;

    const res = await fetch(url);
    if (!res.ok) throw new Error(`DeFi Llama prices responded ${res.status}`);
    const json = await res.json();
    return json.coins || null;
  } catch (err) {
    console.warn("Failed to fetch historical prices:", err.message);
    return null;
  }
}
